import {
    Button,
    Card,
    FormButtonRow,
    FormGroup,
    FormParagraph,
    ProcessItemContainer,
    ProcessItemHeader,
} from '@ksyos/design-system';
import type { IPatientContact } from '../../interfaces/patientContact';
import { ServiceType } from '../../../../common/enums/serviceType';
import { getDisplayName } from '../../../../common/utils/getDisplayName';
import { translateKey } from '../../../translate';

interface IPatientContactItemReadProps {
    contact: IPatientContact;
    isExpanded: boolean;
    onCanUpdate?: () => void;
    onDelete: () => void;
    onUpdate: () => void;
}

export function PatientContactItemRead(props: IPatientContactItemReadProps) {
    if (!props.contact) {
        return null;
    }

    const practitioner = props.contact?.employment?.practitioner;

    return (
        <Card>
            <Card.Transition type="read" />
            <ProcessItemContainer>
                <ProcessItemHeader
                    color="secondary"
                    date={props.contact.date}
                    icon={ServiceType.contact}
                    isOpen={props.isExpanded}
                    onClick={props.onCanUpdate}
                    organizationName={props.contact?.employment?.organization?.name}
                    practitionerName={practitioner ? getDisplayName(practitioner) : undefined}
                    title={translateKey('home.type_contact')}
                />
                {props.contact.report && (
                    <FormGroup label={translateKey('common.report')}>
                        <FormParagraph>{props.contact.report}</FormParagraph>
                    </FormGroup>
                )}
                {props.isExpanded && (
                    <FormButtonRow>
                        <Button
                            onClick={() => props.onDelete()}
                            variant="outline"
                        >
                            {translateKey('common.remove')}
                        </Button>
                        <Button onClick={() => props.onUpdate()}>{translateKey('common.edit')}</Button>
                    </FormButtonRow>
                )}
            </ProcessItemContainer>
        </Card>
    );
}
